<template>
<div :class='[wrapperClasses, { "fw-order-wrapper--disabled": this.disabled }]'
     class='fw-order-wrapper'
     :style='wrapperStyles'
     @mouseenter='hover = true'
     @mouseleave='hover = false'>
    <div class='fw-order-wrapper__text'>
        {{ text }}
    </div>

    <div class='fw-order-icon-wrapper'>
        <FwIcon
            icon='plus'
            size='14'
            :color='iconColor'
            @click.native='handleClick'>
        </FwIcon>
    </div>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

const ORDERS_TYPES: { [key: string]: string } = {
    green: 'fw-order-wrapper--green',
    blue: 'fw-order-wrapper--blue',
    red: 'fw-order-wrapper--red',
    yellow: 'fw-order-wrapper--yellow',
    default: 'fw-order-wrapper--default',
};

const ORDERS_COLOR_MAP: { [key: string]: { mainColor: string, asideColor: string } } = {
    green: {
        mainColor: 'rgba(39,219,189,1)',
        asideColor: 'rgba(39,219,189,0.4)',
    },
    red: {
        mainColor: 'rgba(239,16,60,1)',
        asideColor: 'rgba(239,16,60,0.4)',
    },
    default: {
        mainColor: '#888',
        asideColor: '#EEF0F3',
    },
    blue: {
        mainColor: 'rgba(76,94,225,1)',
        asideColor: 'rgba(76,94,225,0.4)',
    },
    yellow: {
        mainColor: 'rgba(255,204,0,1)',
        asideColor: 'rgba(255,204,0,0.4)',
    },
};

@Component
export default class FwOrder extends Vue {
    @Prop({ type: String, required: true }) readonly text!: string;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: String, default: 'default', validator: (type: string) => ORDERS_TYPES.hasOwnProperty(type) })
    type!: string;

    hover: boolean = false;

    get wrapperClasses() {
        return ORDERS_TYPES[this.type];
    }

    get iconColor(): string {
        return ORDERS_COLOR_MAP[this.type].mainColor;
    }

    get wrapperStyles() {
        return {
            borderColor: !this.disabled && this.hover ?
                ORDERS_COLOR_MAP[this.type].mainColor :
                ORDERS_COLOR_MAP[this.type].asideColor,
            color: ORDERS_COLOR_MAP[this.type].mainColor,
        };
    }

    @Emit('click')
    handleClick() {}
}
</script>

<style lang='sass'>
.fw-order-wrapper
    width: 100%
    border-width: 2px
    border-style: solid
    display: flex
    border-radius: 20px
    padding: 13px 0 13px 20px
    margin: 10px 0
    cursor: default

    &:not(.fw-order-wrapper--disabled)
        .fw-order-icon-wrapper
            cursor: pointer

.fw-order-wrapper__text
    font-size: 16px
    line-height: 1.2em
    color: inherit
    font-weight: bold
    flex: 1
    word-break: break-all

.fw-order-icon-wrapper
    flex: 0 0 50px
    display: flex
    align-items: center
    justify-content: center
</style>
